interface SourceIndicatorProps {
  source: 'BLAST' | 'CRM';
}

const COLOR: Record<SourceIndicatorProps['source'], string> = {
  BLAST: 'bg-blue-500 dark:bg-blue-400',
  CRM: 'bg-gray-400 dark:bg-gray-500',
};

const TOOLTIP: Record<SourceIndicatorProps['source'], string> = {
  BLAST: 'Coach data from Blast.',
  CRM: 'Coach data from CRM only (not in Blast).',
};

export const SourceIndicator = ({ source }: SourceIndicatorProps) => {
  return (
    <span
      title={TOOLTIP[source]}
      className={`inline-block h-1.5 w-1.5 rounded-full flex-shrink-0 ${COLOR[source]}`}
    />
  );
};
